if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.submitButtonTextLabel = this.submitButton?.querySelector('.kg-btn-text');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
            });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, variant = null, formattedPrice = null, isOutOfStock = false) {
        try {
          if (!this.submitButton || !this.submitButtonText) {
            return;
          }

          // Handle out of stock products
          if (isOutOfStock && variant) {
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButton.classList.add('kg-disable');

            let buttonText = '';
            if (this.submitButton.classList.contains('button--preorder')) {
              buttonText = window.variantStrings?.preOrder || 'Pre-order';
            } else {
              buttonText = window.variantStrings?.addToCart || 'Add to cart';
            }

            // Get variant title - handle different cases
            let variantTitle = '';
            try {
              if (variant.title && typeof variant.title === 'string' && variant.title.trim() !== '' && variant.title !== 'Default Title') {
                variantTitle = variant.title.trim();
              } else if (variant.options && Array.isArray(variant.options)) {
                // Construct title from options if title is not available
                variantTitle = variant.options.filter(opt => opt && typeof opt === 'string' && opt.trim() !== '').join(' / ');
              }
            } catch (e) {
              console.warn('Error processing variant title:', e);
            }
            
            // Use provided formatted price, or try to get it from DOM, or format it
            let variantPrice = '';
            
            try {
              if (formattedPrice && typeof formattedPrice === 'string' && formattedPrice.trim() !== '') {
                variantPrice = formattedPrice.trim();
              } else {
                const productInfo = this.closest('product-info');
                if (productInfo) {
                  const sectionId = productInfo.dataset?.section || '';
                  if (sectionId) {
                    const priceElement = document.querySelector(`#price-${sectionId}`);
                    
                    if (priceElement) {
                      // Get the actual displayed price (sale price if available, otherwise regular)
                      const salePrice = priceElement.querySelector('.price-item--sale');
                      const regularPrice = priceElement.querySelector('.price-item--regular');
                      const anyPrice = priceElement.querySelector('.price-item');
                      
                      if (salePrice && salePrice.textContent && salePrice.textContent.trim()) {
                        variantPrice = salePrice.textContent.trim();
                      } else if (regularPrice && regularPrice.textContent && regularPrice.textContent.trim()) {
                        variantPrice = regularPrice.textContent.trim();
                      } else if (anyPrice && anyPrice.textContent && anyPrice.textContent.trim()) {
                        variantPrice = anyPrice.textContent.trim();
                      } else if (variant.price && typeof variant.price === 'number') {
                        variantPrice = this.formatMoney(variant.price);
                      }
                    } else if (variant.price && typeof variant.price === 'number') {
                      variantPrice = this.formatMoney(variant.price);
                    }
                  }
                }
              }
            } catch (e) {
              console.warn('Error processing variant price:', e);
              if (variant.price && typeof variant.price === 'number') {
                variantPrice = this.formatMoney(variant.price);
              }
            }
            
            // Only add price if we have it
            if (variantPrice) {
              if (variantTitle) {
                buttonText = `${buttonText} - ${variantTitle} (${variantPrice})`;
              } else {
                buttonText = `${buttonText} (${variantPrice})`;
              }
            } else if (variantTitle) {
              buttonText = `${buttonText} - ${variantTitle}`;
            }

            this.submitButtonText.textContent = buttonText;
            // Update kg-btn-text span to show "Out of Stock"
            if (this.submitButtonTextLabel) {
              this.submitButtonTextLabel.textContent = 'Out of Stock';
            }
            return;
          }

          // Remove kg-disable class if not out of stock
          this.submitButton.classList.remove('kg-disable');

          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
            // Update kg-btn-text span to show "Out of Stock" when disabled
            if (this.submitButtonTextLabel) {
              this.submitButtonTextLabel.textContent = 'Out of Stock';
            }
          } else {
            this.submitButton.removeAttribute('disabled');

            let buttonText = '';
            if (this.submitButton.classList.contains('button--preorder')) {
              buttonText = window.variantStrings?.preOrder || 'Pre-order';
            } else {
              buttonText = window.variantStrings?.addToCart || 'Add to cart';
            }

            // Add variant name and price if variant data is available
            if (variant && variant.available !== false) {
              // Get variant title - handle different cases
              let variantTitle = '';
              try {
                if (variant.title && typeof variant.title === 'string' && variant.title.trim() !== '' && variant.title !== 'Default Title') {
                  variantTitle = variant.title.trim();
                } else if (variant.options && Array.isArray(variant.options)) {
                  // Construct title from options if title is not available
                  variantTitle = variant.options.filter(opt => opt && typeof opt === 'string' && opt.trim() !== '').join(' / ');
                }
              } catch (e) {
                console.warn('Error processing variant title:', e);
              }
              
              // Use provided formatted price, or try to get it from DOM, or format it
              let variantPrice = '';
              
              try {
                if (formattedPrice && typeof formattedPrice === 'string' && formattedPrice.trim() !== '') {
                  variantPrice = formattedPrice.trim();
                } else {
                  const productInfo = this.closest('product-info');
                  if (productInfo) {
                    const sectionId = productInfo.dataset?.section || '';
                    if (sectionId) {
                      const priceElement = document.querySelector(`#price-${sectionId}`);
                      
                      if (priceElement) {
                        // Get the actual displayed price (sale price if available, otherwise regular)
                        const salePrice = priceElement.querySelector('.price-item--sale');
                        const regularPrice = priceElement.querySelector('.price-item--regular');
                        const anyPrice = priceElement.querySelector('.price-item');
                        
                        if (salePrice && salePrice.textContent && salePrice.textContent.trim()) {
                          variantPrice = salePrice.textContent.trim();
                        } else if (regularPrice && regularPrice.textContent && regularPrice.textContent.trim()) {
                          variantPrice = regularPrice.textContent.trim();
                        } else if (anyPrice && anyPrice.textContent && anyPrice.textContent.trim()) {
                          variantPrice = anyPrice.textContent.trim();
                        } else if (variant.price && typeof variant.price === 'number') {
                          variantPrice = this.formatMoney(variant.price);
                        }
                      } else if (variant.price && typeof variant.price === 'number') {
                        variantPrice = this.formatMoney(variant.price);
                      }
                    }
                  }
                }
              } catch (e) {
                console.warn('Error processing variant price:', e);
                if (variant.price && typeof variant.price === 'number') {
                  variantPrice = this.formatMoney(variant.price);
                }
              }
              
              // Only add price if we have it
              if (variantPrice) {
                if (variantTitle) {
                  buttonText = `${buttonText} - ${variantTitle} (${variantPrice})`;
                } else {
                  buttonText = `${buttonText} (${variantPrice})`;
                }
              } else if (variantTitle) {
                buttonText = `${buttonText} - ${variantTitle}`;
              }
            }

            this.submitButtonText.textContent = buttonText;
            // Update kg-btn-text span to show "Add to Bag" when available
            if (this.submitButtonTextLabel) {
              this.submitButtonTextLabel.textContent = 'Add to Bag';
            }
          }
        } catch (e) {
          console.error('Error in toggleSubmitButton:', e);
          // Fallback to basic text
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
          }
        }
      }

      formatMoney(cents) {
        try {
          if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney && typeof window.Shopify.formatMoney === 'function') {
            const moneyFormat = window.moneyFormat || '{{amount}}';
            return window.Shopify.formatMoney(cents, moneyFormat);
          }
        } catch (e) {
          console.warn('Error using Shopify.formatMoney:', e);
        }
        
        // Fallback: try to get format from theme settings or use default
        try {
          const moneyFormat = window.moneyFormat || '{{amount}}';
          const amount = (cents / 100).toFixed(2);
          return moneyFormat.replace('{{amount}}', amount);
        } catch (e) {
          // Ultimate fallback
          return '$' + (cents / 100).toFixed(2);
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
